var React = require('react');

function Plus1 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24.667 0A3.333 3.333 0 0128 3.333v41.334a3.333 3.333 0 01-6.667 0V3.333A3.333 3.333 0 0124.667 0z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 23.333A3.333 3.333 0 013.333 20h41.334a3.333 3.333 0 010 6.667H3.333A3.333 3.333 0 010 23.333z","key":1})]);
}

Plus1.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Plus1;

Plus1.default = Plus1;
